import React, { Component } from 'react';
import BasicWaveform from 'components/waveform/BasicWaveform.js';

class TrackDetailsDocumentation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedSlice: 0,
            element: undefined,
        };

        if (this.props.sequencerEngine.subSequences[1] !== undefined) {
            this.props.sequencerEngine.switchToSubSequence(
                this.props.sequencerEngine.subSequences[1].id);
        }
    }

    componentWillUnmount() {
        this.props.sequencerEngine.switchToSubSequence(
            this.props.sequencerEngine.subSequences[0].id);
    }

    componentDidMount() {
        this.setState({
            element: document.getElementById("track-details-documentation")
        });
    }

    onSelectSlice(i) {
        this.setState({selectedSlice: i});
    }

    render() {
        let track = this.props.sequencerEngine.tracks[0];
        let sample = track && track.sample;
        let sampler = track && track.getSamplers()[0];
        let buffer = this.state.element === undefined ||
            sampler === undefined  || sampler.baseBuffer === undefined ?
            undefined :
            sampler.baseBuffer.get();

        return (
            <div id="track-details-documentation">
              <p>
                You're probably wondering how to edit the actual sound wavefrom. 
                You can do this by clicking on the thumbnail of a track, bringing you to the <b>Details View</b> for the track.
              </p>
              <p>
                The <b>Details View</b> lets you alter the waveform of your sample and change the track-wide parameters.
              </p>
              <p>
                The waveform editor is shown here:
              </p>
              {buffer === undefined ? '' : 
              <BasicWaveform
                div={this.state.element}
                track={track}
                fullWidth={false}
                selectedSlice={this.state.selectedSlice}
                slices={sampler.slices}
                isReversed={sampler.isReversed()}
                sampler={sampler}
                decentralized={true}
                soundId={sample.getId()}
                onKeyDown={() => []}
                onSelectSlice={(s) => this.onSelectSlice(s)}
                buffer={buffer}></BasicWaveform>}
 
              <p className="sub-header">
                Slicing
              </p>
              <p>
                Each flag in the above editor refers to a different <b>slice</b> of
                the sample. 
                A sample can be broken apart into different slices, each with different start and end times.
              </p>
              <p>
                The <b>start/end times</b> of a slice are represented by the pairs of flags. Drag the flags to change their positions.
              </p>
              <p>
                You can <b>create a new slice</b> by highlighting a region within
                the waveform and then clicking the “Add Slice” button.
              </p>
              <p>
                You can <b>keyboard map</b> each slice to a key on your keyboard by pressing the key. 
                Pressing the key to which the slice is mapped will trigger that slice.
              </p>
             <p className="sub-header">
                Zooming In/Out
              </p>
              <p>
                The waveform viewer supports zooming gentures (like pinching in and out) to zoom into
                the waveform. 
              </p> 
              <p className="sub-header">
                Tempo and Warp
              </p>
              <p>
                The tempo calculated for the sample is shown in red next to the Warp button. When you click “Warp”, the sample will be stretched to match that tempo.
              </p>
              <p className="sub-header">
                Gated/Ungated
              </p>
              <p>
                A <b>gated</b> sample will only trigger
                for as long as the duration of the trigger. An <b>ungated</b> sample
                will stay playing once triggered, until it is triggered again.
              </p>
              <p className="sub-header">
                Parameters
              </p>
              <p>
                You can set the default parameter values for a track by
                using the sliders. Note that these default values will get
                overridden when you set a value for a specific step in the step-sequencer.
              </p>
              <p className="sub-header">
                Key-Mapping Slices
              </p>
              <p>
                The key-mappings of sample slices are shown in the keyboard
                diagram on the page. Click on a specific key icon to unmap
                the key from a slice.
              </p>
              <p className="sub-header">
                Onsets
              </p>
              <p>
                <b>Onsets</b> can be thought as "hits" or "transients" within sample-- high energy, often percussive, events. You can view all onsets by clicking the "Select Onsets" button. 
              </p>
              <p>
                When the onsets are shown, you can select as many onsets you want and then click "Add Slices" to create slices out of the selected onsets.
              </p>
              <p>
                You can use the <b>Onset Threshold</b> slider to adjust the threshold of loudness for considering an onset.
              </p>
            </div>
        );
    }
}

export default TrackDetailsDocumentation;
